var map = {
	"./Hero1.png": 47258,
	"./Hero10.png": 79657,
	"./Hero11.png": 51907,
	"./Hero12.png": 91391,
	"./Hero2.png": 5430,
	"./Hero3.png": 55703,
	"./Hero4.png": 52845,
	"./Hero5.png": 56254,
	"./Hero6.png": 8361,
	"./Hero7.png": 23380,
	"./Hero8.png": 56014,
	"./Hero9.png": 69618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10768;